<template>
  <div>
    <el-drawer
        title="用户权限审阅"
        :visible.sync="drawer"
        direction="rtl"
        size="80%">
      <div style="padding-left: 10px">
        <el-row class='table-search'>
          <el-col :span='24'>
            <el-form :inline='true' size="mini" :model='searchCondition'>
              <el-form-item label=''>
                <el-input v-model='searchCondition.name' placeholder='昵称' clearable></el-input>
              </el-form-item>
<!--              <el-form-item label=''>-->
<!--                <el-input v-model='searchCondition.mobile' placeholder='手机号' clearable></el-input>-->
<!--              </el-form-item>-->
              <el-form-item>
                <el-button type='primary' @click='handleQuery'>查询</el-button>
              </el-form-item>
              <el-form-item>
                <ExportLink ref="refUserPermission" :canExport="true" lintTitle="导出权限"   @export="exportExcel"></ExportLink>
<!--                <el-button type='primary' @click='handleQuery' :l>导出</el-button>-->
              </el-form-item>
            </el-form>
          </el-col>
        </el-row>
        <div>
          <!--    渲染表格-->
          <el-table :loading='loadingStatus' :data='dataList' @sort-change='changeTableSort' border>
            <el-table-column label='序号' type='index' width='100'></el-table-column>
            <el-table-column label='账号' prop='username' width='220'>
              <template slot-scope='{row}'>
                <!--                <el-tag effect='plain' :type='row.userid?"success":"danger"'>{{ row.userid ? '已绑定钉钉' : '未绑定钉钉' }}-->
                <!--                </el-tag>-->
                <!--                <br/>-->
                <span>账号：{{ row.username || '' }}</span> <br/>
                <span>昵称：{{ row.name || '' }}</span><br/>
<!--                <span>手机：{{ row.mobile || '' }}</span><br/>-->
                <div>
                  <b>当前角色：</b>
                  <div v-if='row.role_names&&row.role_names.length>0'>
                    <el-tag type="default" size="mini" style='margin:2px' effect='plain'
                            v-for='(role_name,index) in row.role_names' :key='index'>
                      {{ role_name || '' }}
                    </el-tag>
                  </div>
                  <div v-else>
                    <el-tag type="info" size="mini" effect="plain">暂无</el-tag>
                  </div>
                </div>
              </template>
            </el-table-column>
            <el-table-column label='权限菜单' width="300">
              <template slot-scope='{row}'>
                <div v-if='row.permission_ids' style='height: 200px;overflow-y: scroll'>
                  <PermissionMap :permissions-list='permissionsList'
                                 :checked-node-ids='row.permission_ids'></PermissionMap>
                </div>
              </template>
            </el-table-column>
            <el-table-column label="拥有的权限明细" min-width="400">
              <template slot-scope="{row}">
                <div>{{row.permissions}}</div>
              </template>
            </el-table-column>
          </el-table>
          <!--    渲染分页-->
          <pagination :total.sync='total' :limit.sync='pagingData.page_size' :page.sync='pagingData.current_page'
                      @pagination='getList'/>
        </div>
      </div>

    </el-drawer>

  </div>
</template>

<script>

import PermissionMap from './components/PermissionMap'
// import {handleTree} from '@/utils/index.js'
import {exportUserPurview, getUserPurviewList} from "@/api/user";
import {getRoleDialogList} from "@/api/role";

export default {
  name: 'UserPurview',
  components: {
    PermissionMap,
  },
  data() {
    return {
      drawer: false,
      loadingStatus: false,
      // 搜索条件
      searchCondition: {name: null, mobile: null},
      // 分页信息
      pagingData: {
        current_page: 1,
        page_size: 5
      },
      total: 0,
      // 分页的offset,序号列使用
      offset: 0,
      dataList: [],
      permissionsList: [],
      defaultProps: {
        children: 'children',
        label: 'name'
      }
    }
  },
  methods: {
    async show() {
      this.drawer = true
      await this.loadPermissionsList()
      await this.handleQuery()
    },
    async exportExcel() {
      try {
        const fileName='用户权限'
        let searchCondition = this.handleSearchCondition()
        const response = await exportUserPurview(searchCondition)
        this.$refs['refUserPermission'].exportSaveXlsx(response, fileName)
      } catch (e) {
        this.$message.warning('导出异常，请联系管理员')
      }
    },
    handleQuery() {

      this.pagingData.current_page = 1

      this.getList()
    },
    async getList() {
      this.dataList = []
      this.loadingStatus = true
      let searchCondition = this.handleSearchCondition()
      // 合并
      Object.assign(searchCondition, this.pagingData)
      let {list, pages} = await getUserPurviewList(searchCondition).then((resp) => {
        return resp.model || {}
      })
      this.dataList = list || []
      this.total = pages.total || 0
      this.pagingData.current_page = pages.current_page
      this.pagingData.page_size = pages.page_size
      this.loadingStatus = false
    },
    // 处理搜索条件
    handleSearchCondition() {
      let condition = {}
      Object.keys(this.searchCondition).forEach((k) => {
        if (this.searchCondition[k])
          condition[k] = this.searchCondition[k]
      })
      // if (this.searchCondition.nickname) {
      //   condition.nickname = this.searchCondition.nickname
      // }

      // if (this.searchCondition.login_method) {
      //   condition.login_method = this.searchCondition.login_method
      // }
      // if (this.searchCondition.real_ip) {
      //   condition.real_ip = this.searchCondition.real_ip
      // }
      // if (this.searchCondition.time_value) {
      //   condition.start_time = this.searchCondition.time_value[0]
      //   condition.end_time = this.searchCondition.time_value[1]
      // }
      return condition
    },
    changeTableSort({prop, order}) {
      let orderSort = {}
      if (order) {
        orderSort[prop] = order === 'descending' ? 'desc' : 'asc'
      }
      this.orderSort = orderSort
      this.getList()

    },
    async loadPermissionsList() {
      await getRoleDialogList().then(res => {
        this.permissionsList = res.model || [];
      })
      // let {list} = await this.$api.getUserPermissionRange()
      // this.permissionsList = handleTree(list, 'id', 'parent_id', 'children')

      // this.permissionsList = JSON.parse(JSON.stringify(list))
      // this.permissionsList = JSON.parse(JSON.stringify(list)).map(item => { // 展示数据
      //   // hasChildren 表示需要展示一个箭头图标
      //   item.hasChildren = item.children && item.children.length > 0
      //   // 只展示一层
      //   // 如果有children数据，会自动加载，就不是懒加载了，也可以配置tree-props里面的children为其他字段
      //   item.children = null
      //   // 记住层级关系
      //   item.idList = [item.id]
      //   return item
      // })


    }
  },
  created() {
    // this.loadPermissionsList()
    // this.handleQuery()
  }
}
</script>

<style scoped>
.chart-box {
  width: 50%;

}
</style>
